import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  pharmacyId: string().required(),
})

export const url = ({ pharmacyId }) => `/v1/pharmacies/${pharmacyId}`
